import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import {
    Dialog,
    Flex,
    Button,
    DialogTitle,
    PriorityIcon
} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {onboardingMessageStore} from '../../store/OB_Message_Store';
import {messageType} from '../../../../_shared/Messages/consts';
import texts from '../../texts';
import {approveWarning} from '../../service/api/general';

const MessageType = priority.netitems.shared.Message.Type;

const TitleIcons = {
    [messageType.confirm]: PriorityIcon.questionCircle,
    [messageType.error]: PriorityIcon.attention
};

export const FormWarningAlert = observer(() => {
    const {message: messageData, clearMessage} = onboardingMessageStore;
    const {message, Session, ConfirmCallback} = messageData || {};

    const onClose = useCallback(() => clearMessage(), [clearMessage]);

    const onAccept = useCallback(async () => {
        try {
            await approveWarning(Session);
            await ConfirmCallback?.();
            onClose();
        } catch (e) {
            console.error(e);
        }
    }, [onClose, Session, ConfirmCallback]);

    const renderFooter = useCallback(() => {
        if (message.MType === MessageType.Warning) {
            return (
                <Flex>
                    <Button skin="secondary" onClick={onClose}>
                        {texts.message_cancel}
                    </Button>
                    <Button skin="primary" onClick={onAccept} autoFocus>
                        {texts.message_confirm}
                    </Button>
                </Flex>
            );
        }

        return (
            <Flex>
                <Button autoFocus skin="outline-attention" onClick={onClose}>
                    {texts.message_confirm}
                </Button>
            </Flex>
        );
    }, [onClose, onAccept, message]);

    if (message?.MType === MessageType.Warning || message?.MType === MessageType.Error) {
        return (
            <Dialog
                zIndex={11000}
                isOpen={!!messageData}
                onClose={onClose}
                width={320}
                title={
                    <DialogTitle
                        title={message?.Text}
                        icon={TitleIcons[message.MType]}
                        skin="text"
                        textColor="primary-700"
                    />
                }
                footer={renderFooter()}
            />
        );
    }
    return null;
});
